import { useAuthContext } from '@repo/hooks';
import React, { useEffect } from 'react';

export default function Logout() {
  const { user, cleanupAndLogout } = useAuthContext();

  useEffect(() => {
    if (user) {
      cleanupAndLogout();
    }
  }, []);

  return <></>;
}
